import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 3.25em;
  .MuiTypography-root {
    font-size: 1em;
    font-weight: 600;
  }
`;

interface Props {
  quadrants: (number | string)[];
}

export const QuadrantsGrid = ({ quadrants }: Props) => {
  if (!quadrants.length) return null;

  return (
    <StyledDiv>
      {quadrants.map((quadrant) => (
        <Typography key={quadrant}>{quadrant}</Typography>
      ))}
    </StyledDiv>
  );
};
